import styled from 'styled-components'

export const FilterContainer = styled.div`
  & > form {
    width: 100%;
  }
`

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  .issued-at {
    font-size: 0.9rem;
    color: #7e8299;
    margin-top: 0.25rem;
  }

  button {
    margin-top: 1em;
    background-color: #f3f3f3;
    svg {
      margin-right: 8px;
    }
    &:hover {
      background-color: #d3d3d3;
    }
  }
`

export const ReportTable = styled.table`
  width: 100%;
  table-layout: fixed;
  margin-top: 1rem;
  th,
  td {
    padding: 0.75rem;
    vertical-align: top;
    border-bottom: 1px solid #eff2f5;
    word-wrap: break-word;
  }

  th:nth-child(3),
  td:nth-child(3),
  th:nth-child(4),
  td:nth-child(4),
  th:nth-child(5),
  td:nth-child(5) {
    width: 18%;
  }
  th {
    font-weight: 600;
    background: #f9f9f9;
  }

  th.index-col,
  td.index-col {
    text-align: center;
    vertical-align: middle;
    width: 3rem;
  }
`

export const StatusBadge = styled.span<{ pending?: boolean }>`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  color: ${({ pending }) => (pending ? '#b45309' : '#1f2937')};
  background-color: ${({ pending }) => (pending ? '#fef3c7' : '#f3f4f6')};
`
